

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

type StyleChangeConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentStyle?: string;
  newStyle: string;
};

export function StyleChangeConfirmationDialog({
  open,
  onClose,
  onConfirm,
  currentStyle,
  newStyle,
}: StyleChangeConfirmationDialogProps) {
  const { t } = useTranslation();

  const getStyleName = (style: string) => {
    switch (style) {
      case 'style1':
        return t('dashboard.style_dialog.realism');
      case 'style2':
        return t('dashboard.style_dialog.western');
      case 'style3':
        return t('dashboard.style_dialog.manga');
      case 'custom':
        return t('dashboard.style_dialog.custom');
      default:
        return style;
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>{t('dashboard.style_dialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('dashboard.style_dialog.about_to')}
          {currentStyle && ` ${t('dashboard.style_dialog.from')} ${getStyleName(currentStyle)}`} {t('dashboard.style_dialog.to')}{' '}
          <strong>{getStyleName(newStyle)}</strong>.
        </DialogContentText>
        <DialogContentText sx={{ mt: 2, color: 'warning.main' }}>
          ⚠️ <strong>{t('dashboard.style_dialog.important')}</strong> {t('dashboard.style_dialog.warning')}
        </DialogContentText>
        <DialogContentText sx={{ mt: 2 }}>
          {t('dashboard.style_dialog.are_you_sure')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button onClick={onClose}>{t('dashboard.style_dialog.cancel')}</Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {t('dashboard.style_dialog.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
